import { DEMO_EXAMS, type DemoExam } from "@constants/demo";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { zustandStorage } from "../helpers/storage";

/* -----------------Types--------------- */

type State = {
	currentExam: DemoExam;
	currentModuleId?: string;
	exams: DemoExam[];
	setCurrentExam: (examId: string) => void;
	setCurrentModuleId: (id?: string) => void;
	setDemoExams: (exams: DemoExam[]) => void;
};

/* -----------------Store--------------- */
export const useDemoExamStore = create<State>()(
	persist(
		(set) => ({
			exams: DEMO_EXAMS,
			currentExam: DEMO_EXAMS[0],
			currentModuleId: undefined,
			setCurrentExam: (examId) =>
				set({
					currentExam:
						DEMO_EXAMS.find((exam) => exam.id === examId) ?? DEMO_EXAMS[0],
					currentModuleId: undefined,
				}),
			setCurrentModuleId: (id) => set({ currentModuleId: id }),
			setDemoExams: (exams) => set({ exams }),
		}),
		{
			name: "demo-exam-store",
			storage: createJSONStorage(() => zustandStorage),
		},
	),
);
